import React from 'react';
import FormRow from './FormRow';
import Input from 'components/forms/Input';
import InputLabel from '../common/InputLabel';
import Button from 'components/forms/Button';
import ErrorLabel from '../common/ErrorLabel';
import messages from './messages';

import { FormattedMessage } from 'react-intl';

const rowStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    marginBottom: '1em',
};

const Requirements = ({ formState, onSubmit, setInput, currency, error }) => (
    <div>
        <FormRow style={rowStyle}>
            <InputLabel
                text={<FormattedMessage {...messages.totalRooms} />}
                style={{
                    width: '25%',
                    alignContent: 'center',
                }}
            />
            <Input
                name="totalRooms"
                placeholder="0"
                className="rateChaImp-form-number"
                onChange={(event) => setInput('totalRooms', event.target.value)}
                value={formState.totalRooms}
                addonAfter={<FormattedMessage {...messages.roomsSuffix} />}
            />
        </FormRow>
        <FormRow style={rowStyle}>
            <InputLabel text={<FormattedMessage {...messages.currentRate} />} style={{ width: '25%' }} />
            <Input
                name="currentRate"
                placeholder="0"
                className="rateChaImp-form-number"
                onChange={(event) => setInput('currentRate', event.target.value)}
                value={formState.currentRate}
                addonBefore={currency}
            />
        </FormRow>
        <FormRow style={rowStyle}>
            <InputLabel text={<FormattedMessage {...messages.proposedRate} />} style={{ width: '25%' }} />
            <Input
                name="proposedRate"
                placeholder="0"
                className="rateChaImp-form-number"
                onChange={(event) => setInput('proposedRate', event.target.value)}
                value={formState.proposedRate}
                addonBefore={currency}
            />
        </FormRow>
        <FormRow style={rowStyle}>
            <InputLabel text={<FormattedMessage {...messages.costOfOccupiedRoom} />} style={{ width: '25%' }} />
            <Input
                name="costOfOccupiedRoom"
                placeholder="0"
                className="rateChaImp-form-number"
                onChange={(event) => setInput('costOfOccupiedRoom', event.target.value)}
                value={formState.costOfOccupiedRoom}
                addonBefore={currency}
            />
        </FormRow>
        <FormRow style={rowStyle}>
            <InputLabel text={<FormattedMessage {...messages.forecastedOccupance} />} style={{ width: '25%' }} />
            <Input
                name="forecastOcc"
                placeholder="0"
                className="rateChaImp-form-number"
                onChange={(event) => setInput('forecastedOcc', event.target.value)}
                value={formState.forecastedOcc}
                addonAfter="%"
            />
            <InputLabel
                text={<FormattedMessage {...messages.forecastedActual} />}
                style={{ width: '25%', textAlign: 'center' }}
            />
            <Input
                name="forecastActual"
                placeholder="0"
                className="rateChaImp-form-number"
                readOnly
                addonAfter={<FormattedMessage {...messages.roomsSuffix} />}
                value={Math.round((formState.totalRooms * formState.forecastedOcc) / 100).toString()}
            />
        </FormRow>
        <div className="rateChaImp-error-row">
            {error && (
                <div className="rateChaImp-error-message">
                    <ErrorLabel text={<FormattedMessage {...messages.errorMessage} />} />
                </div>
            )}
        </div>

        <div className="rateChaImp-form-submit-row">
            <Button size="medium" type="primary" onClick={onSubmit} className="rateChaImp-form-submit">
                <FormattedMessage {...messages.calculateButtonLabel} />
            </Button>
        </div>
    </div>
);

export default Requirements;
